import { render, staticRenderFns } from "./interactive-image.vue?vue&type=template&id=62a8974b&scoped=true&"
import script from "./interactive-image.vue?vue&type=script&lang=js&"
export * from "./interactive-image.vue?vue&type=script&lang=js&"
import style0 from "./interactive-image.vue?vue&type=style&index=0&id=62a8974b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8974b",
  null
  
)

export default component.exports